module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    attrs: {
      "id": "register-box"
    }
  }, [_c('div', {
    staticClass: "bgshade-box",
    attrs: {
      "id": "login"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "con-box"
  }, [_c('div', {
    staticClass: "form-box"
  }, [_c('p', {
    staticClass: "title-row"
  }, [_c('span', {
    staticClass: "login-tit"
  }, [_vm._v("注册")]), _vm._v(" "), _c('span', {
    staticClass: "login-close",
    on: {
      "click": _vm.closePopupR
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "regTab"
  }, [_c('div', {
    staticClass: "regBtn",
    on: {
      "click": _vm.changeRegisterWay
    }
  }, [_c('span', {
    ref: "mobileReg",
    class: {
      active: _vm.moibleIsActive
    }
  }, [_vm._v("手机注册")]), _vm._v(" "), _c('span', {
    ref: "emailReg",
    class: {
      active: _vm.emailIsActive
    }
  }, [_vm._v("邮箱注册")])])]), _vm._v(" "), (_vm.userTips.registerResTips) ? _c('p', {
    staticClass: "info-row tips tipsTop"
  }, [_vm._v("\n          " + _vm._s(_vm.userTips.registerResTips) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.moibleIsActive) ? _c('div', [_c('p', {
    staticClass: "info-row"
  }, [_c('input', {
    staticClass: "input-text",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "text"
    }
  }), _vm._v(" "), (_vm.placeholder.registerUserIdM) ? _c('label', {
    staticClass: "simulate-placeholder",
    attrs: {
      "for": "registerUserIdM"
    },
    on: {
      "click": _vm.ie9hideInputIdM
    }
  }, [_vm._v("手机号")]) : _vm._e(), _vm._v(" "), _c('input', {
    key: "mobile-input",
    ref: "userIDMobile",
    staticClass: "input-text",
    attrs: {
      "type": "text",
      "placeholder": "手机号",
      "id": "registerUserIdM",
      "autocomplete": "off"
    },
    on: {
      "blur": _vm.checkUser,
      "focus": _vm.ie9hideInputIdM
    }
  })]), _vm._v(" "), (_vm.userTips.userIdTips) ? _c('p', {
    staticClass: "info-row tips"
  }, [_vm._v("\n            " + _vm._s(_vm.userTips.userIdTips) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.userTips.goLoginTips) ? _c('p', {
    staticClass: "info-row tips"
  }, [_vm._v("\n            用户名已经存在\n          ")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "pwd-row info-row"
  }, [_c('input', {
    staticClass: "input-text",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "password"
    }
  }), _vm._v(" "), (_vm.placeholder.registerUserPwdM) ? _c('label', {
    staticClass: "simulate-placeholder",
    attrs: {
      "for": "registerUserPwdM"
    },
    on: {
      "click": _vm.ie9hideInputPwdM
    }
  }, [_vm._v("设置密码   6~18位数字、字母")]) : _vm._e(), _vm._v(" "), _c('input', {
    key: "pwdM",
    ref: "userPwdMobile",
    staticClass: "input-text",
    attrs: {
      "type": "password",
      "id": "registerUserPwdM",
      "placeholder": "设置密码   6~18位数字、字母",
      "autocomplete": "off"
    },
    on: {
      "blur": _vm.checkPwd,
      "focus": _vm.ie9hideInputPwdM
    }
  }), _vm._v(" "), (_vm.showpwd) ? _c('img', {
    key: "ms1",
    ref: "showpwdM",
    attrs: {
      "src": require("../../assets/user/showpwd.png")
    },
    on: {
      "click": _vm.pwdIsShow
    }
  }) : _vm._e(), _vm._v(" "), (_vm.hidepwd) ? _c('img', {
    key: "mh2",
    ref: "showpwdM",
    attrs: {
      "src": require("../../assets/user/hidepwd.png")
    },
    on: {
      "click": _vm.pwdIsShow
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.userTips.userPwdTipsMobile) ? _c('p', {
    staticClass: "info-row tips"
  }, [_vm._v("\n            " + _vm._s(_vm.userTips.userPwdTipsMobile) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "security-row",
    staticStyle: {
      "position": "relative"
    }
  }, [(_vm.placeholder.registerUserSecM) ? _c('label', {
    staticClass: "simulate-placeholder",
    attrs: {
      "for": "registerUserSecM"
    },
    on: {
      "click": _vm.ie9hideInputSecM
    }
  }, [_vm._v("验证码")]) : _vm._e(), _vm._v(" "), _c('input', {
    ref: "secCode",
    staticClass: "input-text input-code",
    attrs: {
      "type": "text",
      "id": "registerUserSecM",
      "name": "vcode",
      "placeholder": "验证码"
    },
    on: {
      "blur": _vm.checkSecCode,
      "focus": _vm.ie9hideInputSecM
    }
  }), _vm._v(" "), _c('input', {
    ref: "sendCode",
    staticClass: "input-text input-codebtn",
    class: {
      isSend: _vm.isSend, isPhone: _vm.isPhone
    },
    attrs: {
      "type": "button",
      "value": "发送验证码"
    },
    on: {
      "click": _vm.sendCode
    }
  })]), _vm._v(" "), (_vm.userTips.userSecTips1) ? _c('p', {
    staticClass: "info-row tips"
  }, [_vm._v("\n            验证码不正确\n          ")]) : _vm._e(), _vm._v(" "), (_vm.userTips.userSecTips2) ? _c('p', {
    staticClass: "info-row tips"
  }, [_vm._v("\n            请填写验证码\n          ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.emailIsActive) ? _c('div', [_c('p', {
    staticClass: "info-row"
  }, [_c('input', {
    staticClass: "input-text",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "text"
    }
  }), _vm._v(" "), (_vm.placeholder.registerUserIdE) ? _c('label', {
    staticClass: "simulate-placeholder",
    attrs: {
      "for": "registerUserIdE"
    },
    on: {
      "click": _vm.ie9hideInputIdE
    }
  }, [_vm._v("邮箱")]) : _vm._e(), _vm._v(" "), _c('input', {
    key: "email-input",
    ref: "userIDEmail",
    staticClass: "input-text",
    attrs: {
      "type": "text",
      "placeholder": "邮箱",
      "value": "",
      "id": "registerUserIdE",
      "autocomplete": "off"
    },
    on: {
      "blur": _vm.checkUser,
      "focus": _vm.ie9hideInputIdE
    }
  })]), _vm._v(" "), (_vm.userTips.userIdTipsEmail) ? _c('p', {
    staticClass: "info-row tips"
  }, [_vm._v("\n            " + _vm._s(_vm.userTips.userIdTipsEmail) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "pwd-row info-row"
  }, [_c('input', {
    staticClass: "input-text",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "password"
    }
  }), _vm._v(" "), (_vm.placeholder.registerUserPwdE) ? _c('label', {
    staticClass: "simulate-placeholder",
    attrs: {
      "for": "registerUserPwdE"
    },
    on: {
      "click": _vm.ie9hideInputPwdE
    }
  }, [_vm._v("设置密码   6~18位数字、字母")]) : _vm._e(), _vm._v(" "), _c('input', {
    key: "pwdE",
    ref: "userPwdEmail",
    staticClass: "input-text",
    attrs: {
      "type": "password",
      "autocomplete": "off",
      "id": "registerUserPwdE",
      "placeholder": "设置密码   6~18位数字、字母",
      "value": ""
    },
    on: {
      "blur": _vm.checkPwd,
      "focus": _vm.ie9hideInputPwdE
    }
  }), _vm._v(" "), (_vm.showpwd) ? _c('img', {
    key: "es1",
    ref: "showpwdE",
    attrs: {
      "src": require("../../assets/user/showpwd.png")
    },
    on: {
      "click": _vm.pwdIsShow
    }
  }) : _vm._e(), _vm._v(" "), (_vm.hidepwd) ? _c('img', {
    key: "eh2",
    ref: "showpwdE",
    attrs: {
      "src": require("../../assets/user/hidepwd.png")
    },
    on: {
      "click": _vm.pwdIsShow
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.userTips.userPwdTipsEmail) ? _c('p', {
    staticClass: "info-row tips"
  }, [_vm._v("\n            " + _vm._s(_vm.userTips.userPwdTipsEmail) + "\n          ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "agreement-row"
  }, [_c('label', {
    staticClass: "label-agree",
    on: {
      "click": function($event) {
        _vm.agreeStatue = !_vm.agreeStatue
      }
    }
  }, [(_vm.agreeStatue) ? _c('img', {
    attrs: {
      "src": require("../../assets/images/common/selected_icon.png")
    }
  }) : _vm._e()]), _vm._v(" "), _c('span', [_vm._v("同意"), _c('a', {
    staticStyle: {
      "color": "#b11828"
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.getUserAgreement
    }
  }, [_vm._v("《用户协议》")])])]), _vm._v(" "), (_vm.userTips.agreementTips) ? _c('p', {
    staticClass: "info-row tips"
  }, [_vm._v("\n          " + _vm._s(_vm.userTips.agreementTips) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "submit-row"
  }, [_c('button', {
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.userRegister
    }
  }, [_vm._v("立即注册")])]), _vm._v(" "), _c('p', {
    staticClass: "no-userID"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.goLogin
    }
  }, [_vm._v("使用IP360账号登录")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ab55efa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/Register.vue
// module id = 754
// module chunks = 1